var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "agn3xhtb7a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#agn3xhtb7a)",
    transform: "translate(-1089.000000, -345.000000) translate(1040.000000, 0.000000) translate(40.000000, 336.000000) translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12.75 8.578c0 1.277-.338 2.53-.976 3.626-.195.334-.624.447-.956.25-.333-.197-.444-.627-.249-.962.513-.88.784-1.887.784-2.914v-.61c0-.387-.313-.702-.699-.702H2.096c-.386 0-.699.315-.699.703v.61c0 3.178 1.82 5.765 4.978 5.765.934 0 1.824-.219 2.646-.65.342-.18.764-.047.942.298.178.344.046.769-.296.948-1.009.53-2.147.81-3.292.81C2.446 15.75 0 12.533 0 8.578v-.61C0 6.807.94 5.86 2.096 5.86h1.152V3.444C3.248 1.545 4.815 0 6.741 0h-.017c1.926 0 3.493 1.545 3.493 3.444v.306c0 .388-.313.703-.699.703-.385 0-.698-.315-.698-.703v-.306c0-1.123-.94-2.038-2.096-2.038h.017c-1.156 0-2.096.915-2.096 2.038V5.86h6.01c1.155 0 2.095.947 2.095 2.11v.61zm-6.376 4.336c.385 0 .698-.315.698-.703v-1.542c.358-.231.595-.635.595-1.095 0-.718-.578-1.3-1.292-1.3-.714 0-1.292.582-1.292 1.3 0 .459.236.862.592 1.093v1.544c0 .388.313.703.699.703z",
    transform: "translate(2.250000, 0.750000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnblock);
export default __webpack_public_path__ + "static/media/icon-unblock.45d87518ecc643ae0170f8232528eeb5.svg";
export { ForwardRef as ReactComponent };